/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationName: {
    id: "NavigationUser.configurationName",
    defaultMessage: "Configuration Overview",
  },
  accountName: {
    id: "NavigationUser.accountName",
    defaultMessage: "Login & Security",
  },
  adressesName: {
    id: "NavigationUser.adressesName",
    defaultMessage: "List of constructions",
  }
});

export default MESSAGES;